const FOOTER_LINKS = [
  {
    title: '서비스',
    links: ['페인트 시공', '도장 서비스', '방수 공사', '특수 시공'],
  },
  {
    title: '회사 정보',
    links: ['회사 소개', '시공 사례', '고객 후기', '채용 정보'],
  },
  {
    title: '고객 지원',
    links: ['견적 문의', '자주 묻는 질문', 'A/S 신청', '시공 가이드'],
  },
];

const scrollTo = (id: string) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  return (
    <footer className="bg-stone-800 text-white pt-14 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand Column */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/647a8474-0078-433a-9220-18bd877ee07e.png"
              alt="라인 인테리어 로고"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-5">
              페인트·도장·방수 전문 업체<br />
              라인 인테리어와 함께<br />
              공간의 가치를 높이세요.
            </p>
            {/* Social Icons */}
            <div className="flex gap-2">
              {[
                { icon: 'ri-kakao-talk-fill', label: '카카오톡' },
                { icon: 'ri-instagram-line', label: '인스타그램' },
                { icon: 'ri-youtube-line', label: '유튜브' },
                { icon: 'ri-blog-line', label: '블로그' },
              ].map((s) => (
                <button
                  key={s.label}
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:bg-blue-600 hover:border-blue-600 hover:text-white transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </button>
              ))}
            </div>
          </div>

          {/* Link Columns */}
          {FOOTER_LINKS.map((col) => (
            <div key={col.title}>
              <h5 className="font-bold text-sm text-white mb-4">{col.title}</h5>
              <div className="h-px bg-white/10 mb-4" />
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <button
                      onClick={() => {
                        if (link === '견적 문의') scrollTo('#contact');
                        else if (link === '시공 사례') scrollTo('#portfolio');
                        else if (link === '고객 후기') scrollTo('#reviews');
                        else if (link === '회사 소개') scrollTo('#about');
                      }}
                      className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap text-left"
                    >
                      {link}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            © 2025 라인 인테리어. All rights reserved. | 사업자등록번호: 000-00-00000
          </p>
          <div className="flex gap-4">
            {['이용약관', '개인정보처리방침'].map((t) => (
              <button
                key={t}
                className="text-white/40 hover:text-white/70 text-xs transition-colors cursor-pointer whitespace-nowrap"
              >
                {t}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
